import config from './../modules/Config/Config';

window._qevents = [];

export default (function() {

  // Load the quantcast library
  (function () {
    var elem = document.createElement('script');
    elem.src = (document.location.protocol == "https:" ? "https://secure" : "http://edge") + ".quantserve.com/quant.js";
    elem.async = true;
    elem.type = "text/javascript";
    var scpt = document.getElementsByTagName('script')[0];
    if (scpt) {
      scpt.parentNode.insertBefore(elem, scpt);
    }
  })();

  // Create a list of tracking codes that should get tracked to
  var trackingList = [];

  let qconf = config.quantcast || [];

  // Add each tracking code from the configuration to the list
  for (var i = qconf.length - 1; i >=0; i--) {

    // Add the a tracking object for this code to the list
    trackingList.push(
      {
        qacct: qconf[i].key
      }
    );
  }

  // Track the page quantcast
  _qevents.push(trackingList);

  return _qevents;
})()